import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import { Link } from "react-router-dom"
import GlobalHelper from "../../common/GlobalHelper"
import Icon from "../../common/icon/icon.component"
import AuthService from "../../state/auth/AuthService"
import PasswordRequirementToolTip from "../../user/form/PasswordRequirementToolTip"
import PasswordStrengthVerificationInput from "../../user/form/PasswordStrengthVerificationInput"


type Props = {
    userID: string,
    hash: string,
}

const messages = defineMessages({
    password_rules_error: {
        id: "user.password_missing_requirements_label",
        defaultMessage: "Password is missing one or more requirements :",
    },
    password_strength_error: {
        id: "user.password_rules.easily_guessable",
        defaultMessage: "Unfortunately your password is easily guessable. Please try a different password.",
    },
    password_match_error: {
        id: "user.password_match_label",
        defaultMessage: "Passwords do not match",
    },
    enter_password_title: {
        id: "login.reset_password.title_label",
        defaultMessage: "Enter new password",
    },
    new_password_label: {
        id: "login.reset_password.new_password_label",
        defaultMessage: "New password",
    },
    confirm_password_label: {
        id: "login.reset_password.confirm_password_label",
        defaultMessage: "Confirm new password",
    },
    submit_label: {
        id: "login.reset_password.submit_label",
        defaultMessage: "Submit",
    },
    error_label: {
        id: "login.reset_password.sorry_label",
        defaultMessage: "Sorry, this link is either invalid or expired",
    },
    invalid_or_expired_link_message: {
        id: "login.reset_password.invalid_or_expired_link_message",
        defaultMessage: "The link you are trying to use is either expired or invalid.",
    },
    password_change_success_message: {
        id: "login.reset_password.password_change_success_message",
        defaultMessage: "Your new password has been successfully modified.",
    },
    signin: {
        id: "login.forgot_password.signin_label",
        defaultMessage: "Back to Login",
    },
})

const ResetPasswordComponent = (props: Props) => {
    const [newPassword, setNewPassword] = useState("")
    const [confirmationPassword, setConfirmationPassword] = useState("")
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [passwordRuleMessage, setPasswordRuleMessage] = useState(<span/>)
    const [isValid, setIsValid] = useState(true)
    const [isPasswordAcceptable, setIsPasswordAcceptable] = useState(false)

    useEffect(() => {
        setPasswordRuleMessage(<span/>)
    }, [newPassword, confirmationPassword])

    useEffect(() => {
        const validateURL = async () => {
            const res = await AuthService.ValidateResetPasswordLink(props.userID, props.hash)
            setIsValid(res)
        }
        void validateURL()
    }, [])

    const onSubmit = () => {
        if (!GlobalHelper.checkPasswordRules(newPassword)) {
            setPasswordRuleMessage(
                <div>
                    <FormattedMessage{...messages.password_rules_error}/>
                    <PasswordRequirementToolTip/>
                </div>
            )
            return
        }
        if (newPassword !== confirmationPassword) {
            setPasswordRuleMessage(<FormattedMessage{...messages.password_match_error}/>)
            return
        }
        if (!isPasswordAcceptable) {
            setPasswordRuleMessage(<FormattedMessage{...messages.password_strength_error}/>)
            return
        }
        AuthService.ResetPassword(props.userID, props.hash, newPassword)
        setIsSubmitted(true)
    }

    return (!isSubmitted && isValid ?
        <div>
            <h3 className="mt-2 pb-3">
                <FormattedMessage {...messages.enter_password_title}/>
            </h3>

            <div className={"pb-3"}>
                <label>
                    <FormattedMessage {...messages.new_password_label}/>
                </label>
                <input
                    name="newPassword"
                    type="password"
                    id="inputPassword"
                    className="form-control"
                    required
                    onChange={e => setNewPassword(e.target.value)}
                />
                <small className={"text-danger mt-1"}>
                    {passwordRuleMessage}
                </small>
            </div>

            <div className={"pb-3"}>
                <label>
                    <FormattedMessage {...messages.confirm_password_label}/>
                </label>

                <PasswordStrengthVerificationInput
                    value={confirmationPassword}
                    inputName="confirmationPassword"
                    required={true}
                    handleFormChange={e => setConfirmationPassword(e.target.value)}
                    handlePasswordScoreChange={isAcceptable => setIsPasswordAcceptable(isAcceptable)}
                    placeholder={""}
                />
            </div>

            <Button
                onClick={onSubmit}
                className="btn btn-primary col-12">
                <FormattedMessage {...messages.submit_label}/>
            </Button>
        </div> :
        <>
            {isValid ?
                <p className={"text-success mt-3 mb-0 text-justify text-center"}>
                    <FormattedMessage {...messages.password_change_success_message}/>
                </p> :
                <p className={"text-danger mt-3 mb-0 text-justify text-center"}>
                    <Icon value={"exclamation"} className={"mr-1"}/>
                    <FormattedMessage {...messages.invalid_or_expired_link_message}/>
                </p>}
            <div className="col-12 pt-3">
                <p className="text-align-center">
                    <Link to={"/p/signin"}>
                        <FormattedMessage{...messages.signin}/>
                    </Link>
                </p>
            </div>
        </>

    )
}

export default injectIntl(ResetPasswordComponent)


// WEBPACK FOOTER //
// ./src/auth/components/ResetPasswordComponent.tsx